console.log('init_our_game.js loaded!');

/* css for the specific page */
import "./pages-assets/games/our-game/our-game.css";


   

/* scripts for the specific page */
import "./pages-assets/games/our-game/our-game.js";
